"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "Upload",
  props: {
    reportType: String,
    file_url: String
  },
  data: function data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      uploadActionUrl: '/dev-api/file-upload'
    };
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      var isMp4 = file.type === 'video/mp4';
      var isLt50M = file.size / 1024 / 1024 < 50;

      if (!isMp4) {
        this.$message.error('只能上传jpg图片');
        return false;
      }

      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过 50MB!');
        return false;
      }
    },
    onSuccess: function onSuccess(res, file, fileList) {
      this.$emit("success", res, this.reportType);
    }
  }
};
exports.default = _default;